function initmMCSlider() {
  var swiper = new Swiper(".mMCSwiper", {
    slidesPerView: 5,
    spaceBetween: 3,
    navigation: {
      nextEl: ".m-mc-next",
      prevEl: ".m-mc-prev",
      hideOnClick: false,
      disabledClass: "swiper-button-disabled",
      lockClass: "swiper-button-lock"
    },
    breakpoints: {
      1000: {
        slidesPerView: 5,
      },
      0: {
        slidesPerView: 2,
        spaceBetween: 15,
      },
    },
  });
}